module.exports = __webpack_public_path__ + "static/media/arrowLeft.57073e22.svg";